// SSO 왕복 방지(결정 22): 시작할 때 표시를 남기고, 로그인 확인이 되면 지운다
const TRIES = "liquids_sso_tries";

export function startSso(ssoStart, next) {
  try {
    // 새로고침(서비스워커 교체 포함)은 SSO 복귀(navigate)가 아니므로 표시를 무시한다
    const reloaded = performance.getEntriesByType("navigation")[0]?.type === "reload";
    if (!reloaded && sessionStorage.getItem(TRIES) === "1") return false;
    // 다른 호스트(갤러리·yourliq)에서 남긴 표시는 그 origin 에 ssoDone 이 없어 지워지지 않는다
    if (new URL(ssoStart, window.location.href).origin === window.location.origin) sessionStorage.setItem(TRIES, "1");
  } catch {}
  window.location.assign(`${ssoStart}?next=${encodeURIComponent(next)}`);
  return true;
}

export function ssoDone() {
  try { sessionStorage.removeItem(TRIES); } catch {}
}

export const ssoReset = ssoDone;
